import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '../../../../core/core.module';
import { TimeBlockHttpService } from '../../../../core/state/time-blocks/time-block-entries/time-block-http.service';
import { SharedModule } from '../../../../shared/shared.module';
import { TimeCoordinateMappingService } from '../../time-mapping/time-coordinate-mapping.service';
import { TimeBlockContainerDirective } from '../../views/time-block-container.directive';
import { ActiveTimeBlockTrackerService } from './active/active-time-block-tracker.service';
import { ParallelTimeBlockGeometryCalculatorService } from './calculation/geometry/parallel-time-block-geometry-calculator.service';
import { MonthViewSlotVectorService } from './calculation/geometry/parallel-time-block-geometry/month-view-slot-vector.service';
import { ParallelTimeBlockMonthViewCalculatorService } from './calculation/geometry/parallel-time-block-geometry/parallel-time-block-month-view-calculator.service';
import { ParallelTimeBlockWeekViewFixIntervalCalculatorService } from './calculation/geometry/parallel-time-block-geometry/parallel-time-block-week-view-fix-interval-calculator.service';
import { ParallelTimeBlockWeekViewVariableIntervalCalculatorService } from './calculation/geometry/parallel-time-block-geometry/parallel-time-block-week-view-variable-interval-calculator-service';
import { TimeBlockGeometryService } from './calculation/geometry/time-block-geometry.service';
import { TimeBlockIntersectionService } from './calculation/intersection/time-block-intersection.service';
import { TimeBlockCrudService } from './crud/time-block-crud.service';
import { TimeBlockComponentHandlerService } from './generation/time-block-component-handler.service';
import { TimeBlockHydrationService } from './generation/time-block-hydration.service';
import { TimeBlockHighlightingService } from './highlighted/time-block-highlighting.service';
import { TimeBlockHttpCallbackService } from './http/time-block-http-callback.service';
import { TimeBlockHttpTransformationService } from './http/time-block-http-transformation.service';
import { CollisionHandlerService } from './interaction/movement/collision-handling/collision-handler.service';
import { DragHandlerService } from './interaction/movement/drag-and-resize/drag-handler.service';
import { DragAndDropHandlerService } from './interaction/movement/drag-and-resize/dragging/drag-and-drop/drag-and-drop-handler.service';
import { DragDropPositioningService } from './interaction/movement/drag-and-resize/dragging/drag-and-drop/drag-drop-positioning.service';
import { DayOrWeekFixIntervalDragControllerService } from './interaction/movement/drag-and-resize/dragging/drag-view-controller/day-or-week-fix-interval-drag-controller.service';
import { FreelyDayOrWeekDragControllerService } from './interaction/movement/drag-and-resize/dragging/drag-view-controller/freely-day-or-week-drag-controller.service';
import { MonthFixIntervalVariableIntervalDayDragControllerService } from './interaction/movement/drag-and-resize/dragging/drag-view-controller/month-fix-interval-variable-interval-day-drag-controller.service';
import { ResizeCalculatorService } from './interaction/movement/drag-and-resize/resizing/resize-calculator.service';
import { ResizeLaneSwitchService } from './interaction/movement/drag-and-resize/resizing/resize-lane-switch.service';
import { ResizeTimeBlockScheduleCalculatorService } from './interaction/movement/drag-and-resize/resizing/resize-time-block-schedule-calculator.service';
import { HorizontalAllResizeControllerService } from './interaction/movement/drag-and-resize/resizing/resize-view-controller/horizontal-all-resize-controller.service';
import { VerticalDayOrWeekResizeControllerService } from './interaction/movement/drag-and-resize/resizing/resize-view-controller/vertical-day-or-week-resize-controller.service';
import { SharedHorizontalDragResizeService } from './interaction/movement/drag-and-resize/time-block-drag-resize-handling/shared-horizontal-drag-resize.service';
import { TimeBlockDragResizeControllerService } from './interaction/movement/drag-and-resize/time-block-drag-resize-handling/time-block-drag-resize-controller.service';
import { TimeBlockDragResizeMouseHandlerService } from './interaction/movement/drag-and-resize/time-block-drag-resize-handling/time-block-drag-resize-mouse-handler.service';
import { TimeBlockDragResizeDirective } from './interaction/movement/drag-and-resize/time-block-drag-resize-handling/time-block-drag-resize.directive';
import { TimeBlockItemBuilderService } from './generation/time-block-item-builder.service';
import { TimeBlockDragResizeService } from './interaction/movement/drag-and-resize/time-block-drag-resize-handling/time-block-drag-resize.service';
import { InteractHandlerService } from './interaction/movement/interact-handler.service';
import { TimeBlockAccumulatedWorkPipe } from './pipes/time-block-accumulated-work.pipe';
import { TimeBlockColorPipe } from './pipes/time-block-color.pipe';
import { TimeBlockFilterPipe } from './pipes/time-block-filter.pipe';
import { TimeBlockStripedBgImagePipe } from './pipes/time-block-striped-bg-image.pipe';
import { TimeBlockTimeDifferencePipe } from './pipes/time-block-time-difference.pipe';
import { TimeBlockTitlePipe } from './pipes/time-block-title.pipe';
import { TimeBlockElementSelectorService } from './rendering/time-block-element-selector.service';
import { TimeBlockRenderService } from './rendering/time-block-render.service';
import { TimeBlockMonthViewContainerService } from './services/time-block-month-view-container.service';
import { TimeBlockService } from './services/time-block.service';
import { DragEdgeTemplateComponent } from './templates/drag-edge-template/drag-edge-template.component';
import { TimeBlockBodyComponent } from './templates/time-block-body/time-block-body.component';
import { TimeBlockMappingService } from './time-block-structure/time-block-mapping.service';
import { TimeBlockStructureService } from './time-block-structure/time-block-structure.service';
import { TimeBlockComponent } from './time-block.component';

@NgModule({
  imports: [CommonModule, CoreModule, SharedModule],
  declarations: [
    TimeBlockComponent,
    TimeBlockBodyComponent,
    TimeBlockFilterPipe,
    TimeBlockColorPipe,
    TimeBlockStripedBgImagePipe,
    TimeBlockDragResizeDirective,
    TimeBlockContainerDirective,
    DragEdgeTemplateComponent,
    TimeBlockAccumulatedWorkPipe,
    TimeBlockTimeDifferencePipe,
    TimeBlockTitlePipe,
  ],
  providers: [
    VerticalDayOrWeekResizeControllerService,
    ResizeTimeBlockScheduleCalculatorService,
    ResizeLaneSwitchService,
    ResizeCalculatorService,
    SharedHorizontalDragResizeService,
    FreelyDayOrWeekDragControllerService,
    DayOrWeekFixIntervalDragControllerService,
    MonthFixIntervalVariableIntervalDayDragControllerService,
    TimeBlockService,
    TimeBlockMappingService,
    TimeBlockRenderService,
    TimeBlockHttpService,
    TimeCoordinateMappingService,
    TimeBlockCrudService,
    TimeBlockComponentHandlerService,
    DragDropPositioningService,
    TimeBlockStructureService,
    CollisionHandlerService,
    DragAndDropHandlerService,
    TimeBlockDragResizeService,
    TimeBlockItemBuilderService,
    TimeBlockHttpTransformationService,
    TimeBlockGeometryService,
    DragHandlerService,
    HorizontalAllResizeControllerService,
    TimeBlockDragResizeControllerService,
    TimeBlockDragResizeMouseHandlerService,
    TimeBlockElementSelectorService,
    InteractHandlerService,
    TimeBlockHttpCallbackService,
    TimeBlockHighlightingService,
    ParallelTimeBlockGeometryCalculatorService,
    ParallelTimeBlockWeekViewVariableIntervalCalculatorService,
    ParallelTimeBlockWeekViewFixIntervalCalculatorService,
    ParallelTimeBlockMonthViewCalculatorService,
    TimeBlockIntersectionService,
    ActiveTimeBlockTrackerService,
    TimeBlockHydrationService,
    MonthViewSlotVectorService,
    TimeBlockMonthViewContainerService,
  ],
  exports: [TimeBlockContainerDirective, TimeBlockAccumulatedWorkPipe],
})
export class TimeBlockModule {}
